import _getFieldInfo from './_getFieldInfo';
export default _getSortedImportedFields;

function _getSortedImportedFields(bottlebooksFieldsMap) {
  const sorted = Object.keys(bottlebooksFieldsMap)
    .reduce((acc, importFieldName) => {
      const { bottlebooksFieldName } = bottlebooksFieldsMap[importFieldName];
      acc.push({ importFieldName, bottlebooksFieldName });
      return acc;
    }, [])
    .sort((a, b) => {
      const {
        index: indexA,
        baseName: baseNameA,
        isMultiA,
        childNameA,
      } = _getFieldInfo(a.importFieldName);
      const { index: indexB, baseName: baseNameB } = _getFieldInfo(
        b.importFieldName
      );
      if (baseNameA === baseNameB) {
        return simple(parseInt(indexA), parseInt(indexB));
      } else return simple(baseNameA, baseNameB);
    });
  return sorted;

  function simple(i, j) {
    if (i === j) return 0;
    if (i > j) return 1;
    if (i < j) return -1;
  }
}
